import { render, staticRenderFns } from "./SystemPermissionAppendButton.vue?vue&type=template&id=315af696&scoped=true"
import script from "./SystemPermissionAppendButton.vue?vue&type=script&lang=js"
export * from "./SystemPermissionAppendButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315af696",
  null
  
)

export default component.exports